import type { EmbedContext } from '@core/embed';
import { ensureGtag } from './scriptLoaders';

/**
 * Inside a cross-site iframe Chrome refuses gtag's default (Lax) `_ga` cookie,
 * and gtag then sends nothing at all. Partitioned keeps the cookie in the
 * embedding site's jar, which is the right scope for a widget.
 */
export const EMBED_COOKIE_FLAGS = 'SameSite=None;Secure;Partitioned';

/**
 * Must run before any `config` or GTM load: `set` only applies to what is
 * configured after it. `embed_mode` / `embed_host` ride every event so Meitre
 * GA can tell direct traffic from each kind of embed.
 */
export function applyEmbeddedTagging(context: EmbedContext): void {
  ensureGtag();

  if (context.mode === 'direct') {
    window.gtag!('set', { embed_mode: 'direct' });
    return;
  }

  window.gtag!('set', {
    cookie_flags: EMBED_COOKIE_FLAGS,
    embed_mode: context.mode,
    embed_host: context.host ?? '(not set)',
  });
}
